module.exports = __webpack_public_path__ + "img/rd-doctor-patient.84a1aaf0.png";